/**
 * Created by tigran on 18.01.25
 **/

import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const BenefitsIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.6 3.26755C15.3568 3.01912 15.0607 2.82869 14.7338 2.71038C14.4069 2.59208 14.0575 2.54894 13.7117 2.58419C13.3658 2.61944 13.0323 2.73215 12.736 2.91397C12.4397 3.09578 12.1881 3.34203 12 3.63441C11.8119 3.34203 11.5603 3.09578 11.264 2.91397C10.9677 2.73215 10.6342 2.61944 10.2883 2.58419C9.94245 2.54894 9.59309 2.59208 9.26617 2.71038C8.93926 2.82869 8.64321 3.01912 8.39999 3.26755C7.96051 3.71614 7.71436 4.31912 7.71436 4.94712C7.71436 5.57512 7.96051 6.1781 8.39999 6.62669L12 10.2858L15.6 6.62669C16.0395 6.1781 16.2856 5.57512 16.2856 4.94712C16.2856 4.31912 16.0395 3.71614 15.6 3.26755Z"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M5.99998 21.4287L5.99998 19.7144L2.94684 15.8984C2.704 15.5947 2.57162 15.2175 2.57141 14.8287L2.57141 9.85725C2.57141 9.51625 2.70687 9.18923 2.94799 8.94811C3.18911 8.70699 3.51613 8.57153 3.85713 8.57153C4.19812 8.57153 4.52514 8.70699 4.76626 8.94811C5.00738 9.18923 5.14284 9.51625 5.14284 9.85725L5.14284 12.5024"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M10.2857 21.4286L10.2857 16.9955C10.2856 16.5409 10.1049 16.1049 9.78342 15.7835L6.85713 12.8572C6.62972 12.63 6.32143 12.5024 5.99999 12.5024C5.67855 12.5024 5.37026 12.63 5.14285 12.8572C4.91568 13.0846 4.78809 13.3929 4.78809 13.7143C4.78809 14.0358 4.91568 14.3441 5.14285 14.5715L7.71428 17.1429"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M18 21.4287V19.7144L21.0531 15.8984C21.296 15.5947 21.4284 15.2175 21.4286 14.8287V9.85725C21.4286 9.51625 21.2931 9.18923 21.052 8.94811C20.8109 8.70699 20.4838 8.57153 20.1429 8.57153C19.8019 8.57153 19.4748 8.70699 19.2337 8.94811C18.9926 9.18923 18.8571 9.51625 18.8571 9.85725V12.5024"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M13.7142 21.4286V16.9955C13.7143 16.5409 13.895 16.1049 14.2165 15.7835L17.1428 12.8572C17.3702 12.63 17.6785 12.5024 17.9999 12.5024C18.3214 12.5024 18.6297 12.63 18.8571 12.8572C19.0843 13.0846 19.2119 13.3929 19.2119 13.7143C19.2119 14.0358 19.0843 14.3441 18.8571 14.5715L16.2857 17.1429"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
    </svg>
  );
};
